import styled from 'styled-components';

import { token } from '@zillow/constellation';

export const StyledProgressStepperContainer = styled.div`
  background-color: ${token('colors.white')};
  display: flex;
  justify-content: center;
`;

export const StyledProgressStepperContent = styled.div`
  flex: 1;
  max-width: 100%;
`;
